module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av737-53dd0bacd47fe4699a7f87f74f4326a6.jpg";